import RequestDetail from './RequestDetail'
import { useSelector } from "react-redux";

const RequestDetailContainer = (props : any) => {
 const detailsByIdItem = props?.detailsByIdItem;
 const transferOrderByIdData = props?.transferOrderByIdData;
 const requesttype = props?.requesttype;
    
  return (
    <RequestDetail
      transferOrderByIdData={transferOrderByIdData}
      detailsByIdItem = {detailsByIdItem}
      requesttype = {requesttype}
       />
  );
}

export default RequestDetailContainer